import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M18.482 3.068c-.56.05-1.11.127-1.652.229l.37 1.965A15.191 15.191 0 0 1 20.095 5 15 15 0 1 1 6.828 27H11v-2H3v8h2v-5.18A17 17 0 1 0 20.148 3c-.55-.004-1.107.018-1.666.068ZM13.63 4.234c-1.042.42-2.03.94-2.953 1.547l1.098 1.671a14.898 14.898 0 0 1 2.604-1.364l-.749-1.854Zm-5.546 3.64a17.182 17.182 0 0 0-2.136 2.557l1.653 1.127A15.096 15.096 0 0 1 9.487 9.3L8.084 7.874Zm-3.735 5.481a16.901 16.901 0 0 0-.997 3.182l1.958.407a14.9 14.9 0 0 1 .88-2.806l-1.841-.783Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M3 19.852a17.193 17.193 0 0 0 .297 3.318l1.965-.37A15.193 15.193 0 0 1 5 19.866l-2-.015ZM21 20h9v2H19V11h2v9Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var PictogramCoworkingWorkingHours40 = createIcon(IconComponent);